
// DATA FIELDS
export const ID_FIELD = 'id'
export const DEVICE_TYPE_FIELD = 'device.device_type.name'
export const DEPLOYMENT_STATUS_FIELD = 'deployment_status.name'
export const BUNDLE_TYPE_FIELD = 'bundle.name'